/**
 *  ==========================
 *  BLOCK: Forums Block
 *  ==========================
 */

/**
 * WordPress dependencies
 */
import { __ } from '@wordpress/i18n'

/**
 * External dependencies
 */
import { disabledBlocks, i18n } from 'cartzillagb'
import { BlogPostsIcon } from '~cartzillagb/icons'

/**
 * Internal dependencies
 */
import edit from './edit'
import save from './save'

const schema = {
    'orderBy': {
        type: 'string',
        default: 'date'
    },
    'order': {
        type: 'string',
        default: 'DESC'
    },
    'hideMobile': {
        type: 'boolean',
        default: false
    },
    'hideTablet': {
        type: 'boolean',
        default: false
    },
    'hideDesktop': {
        type: 'boolean',
        default: false
    },
    'enableContainer': {
        type: 'boolean',
        default: true
    },
    'displayFeaturedImage': {
        type: 'boolean',
        default: true
    },
    'displayPostTitle': {
        type: 'boolean',
        default: true
    },
    'displayPostContent': {
        type: 'boolean',
        default: true
    },
    'btnText': {
        type : 'text',
        default : 'Read More Posts',
    },
    'btnLink': {
        type : 'string',
        default : '#',
    },
    'btnIcon': {
        type : 'string',
        default : 'czi-arrow-right',
    },
    'postsToShow': {
        type: 'number',
        default: 3,
    },
    'postperSlide': {
        type: 'number',
        default: 3,
    },
    'posts': {
        type: 'array',
        default: []
    },
    'postsId': {
        type: 'string',
        default: '',
    },
    taxonomyType: {
        type: 'string',
    },
    taxonomy: {
        type: 'array',
        default: [],
    },
}

export const name = 'czgb/blog-post'

export const settings = {
    title: __( 'Blog Posts', i18n ),
    description: __( 'Display a list of posts from your Blog.', i18n ),
    icon: BlogPostsIcon,
    example: {},
    category: 'cartzillagb',
    keywords: [
        __( 'Blog Posts Block', i18n ),
        __( 'CartzillaGB', i18n ),
    ],
    attributes: schema,
    supports: {
        inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
    },

    edit,
    save,

    // cartzillaGB modules.
    modules: {
        'advanced-responsive': true,
        'block-title': true,
    },
}
